'use strict';

exports.AnalyzedSuggesterBase = require('./analyzed-suggester-base');

exports.TermSuggester = require('./term-suggester');
exports.DirectGenerator = require('./direct-generator');
exports.PhraseSuggester = require('./phrase-suggester');
exports.CompletionSuggester = require('./completion-suggester');
